<dialog #_innerModal eclModal [variant]="'information'" [size]="'m'"
        (modalClose)="modalClose.emit($event)">
    <header eclModalHeader>
        {{ 'easeportal.modal.MEMBER-STATE' | translate }}
    </header>
    <div eclModalBody>
        <p>{{ 'easeportal.member-state-modal.CONFIRMATION-CONTENT' | translate}}</p>
        <p><strong>{{ 'easeportal.member-state-modal.CONFIRMATION-QUESTION' | translate}}</strong></p>
    </div>
    <footer eclModalFooter>
        <button eclButton eclModalRole="cancel" [eclModalClose]="false" variant="secondary">{{ 'easeportal.common.NO' | translate }}</button>
        <button eclButton eclModalRole="confirm" [eclModalClose]="true" variant="primary">{{ 'easeportal.common.YES' | translate }}</button>
    </footer>
</dialog>
